import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { signUrlVerification } from "../redux/actions/auth";

const SignUrlAuth = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sign_url_token = searchParams.get("token");
  const [message, setMessage] = useState("");

  useEffect(() => {
    if(!sign_url_token){
        setMessage("Please provide valid sign url token or your session is expired.");
        setLoading(false);
        return;
    }

    dispatch(signUrlVerification(sign_url_token, (res) => {
        if(res.status){
            const { booking_id } = res.data;
            setMessage("User is successfully verified.");
            if(booking_id){
              navigate(`/embedded/todo/performance/${booking_id}`, { replace: true });
            }else{
              navigate(`/`, { replace: true });
            }
        }else{
            setMessage("Provided sign url token is expired.");
        }
        setLoading(false);
    }));
  },[sign_url_token])

  return (
    <main className="w-screen h-screen flex justify-center items-center bg-white">
      {(loading && (
        <div>
          <span className="ml-2">
            <svg
              className="animate-spin w-20 h-20 fill-current shrink-0"
              viewBox="0 0 16 16"
            >
              <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
            </svg>
          </span>
        </div>
      )) || (
        <p className="font-md font-inter font-semibold py-3">{message}</p>
      )}
    </main>
  );
};

export default SignUrlAuth;
